/* eslint-disable prefer-destructuring */
export const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN

export const PATH_DOMAIN_CDN = process.env.NEXT_PUBLIC_CLOUDFRONT_ENDPOINT
export const PATH_IMAGES_CDN = `${PATH_DOMAIN_CDN}/images`

export const API_BASE_URL = process.env.API_GATEWAY || process.env.NEXT_PUBLIC_API_GATEWAY
